<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="calificacion" titulo="Calificación / Control Escolar" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div id="banner" align="center" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo || cargando">
  <div class="bloquear-azul">

  </div>
  <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
    <span class="icon">
      <i class="icon-worldwide fa-spin"></i>
    </span> &nbsp;
    <span>Cargando...</span>
  </span>
</div>

<div class="contenedor columns " style="height:100%; ">
  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; height:100%;">

      <!-- formulario -->
      <form name="form" novalidate >
        <section class="hero is-primary">
          <div class="hero-body">

            <!-- Opciones  -->
            <section class="hero is-primary">
              <div class="hero-head">
                <nav class="level">
                  <!-- Left side -->
                  <div class="level-left">
                    <div class="level-item">
                      <p class="title">
                        <span *ngIf="!ctrl.cargando" class="icon is-medium">
                          <i class="icon-certificate"></i>
                        </span>
                        <span *ngIf="ctrl.cargando  || cargando" class="icon is-medium">
                          <i class="icon-worldwide fa-spin"></i>
                        </span>
                        <span class="icon is-medium">
                          <i class="icon-file"></i>
                        </span> Constancias
                      </p>
                    </div>

                  </div>

                  <!-- Right side -->
                  <div class="level-right">

                    <a class="navbar-item is-primary tooltip" (click)="ctrl.regresar()">
                      <span class="icon fa-2x">
                        <i class="icon-back"> </i>
                      </span>
                      <span class="tooltiptext">Regresar</span>
                    </a>

                    <a class="navbar-item is-primary tooltip" (click)="cargarDatos()" >
                      <span class="icon fa-2x">
                        <i class="icon-search "></i>
                      </span>
                      <span class="tooltiptext">Buscar</span>
                    </a>

                  </div>
                </nav>
              </div>
            </section>
          </div>
        </section>

        <a id="catalogos" (click)="ctrl.cargarCatalogo('eventos', 'evento'); ctrl.cargarCatalogo('logos64', 'logos64', 'logo64');"></a>
        <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>

        <section class="section" style="overflow-y:auto; overflow-x:hidden; padding: 1rem; height: 86vh;">

          <div class="columns">
            <div class="column is-12">
              <label class="label">Evento:</label>
              <div class="control has-icons-left has-icons-right">

                <ng-select2 [disabled]="ctrl.eventos ? ctrl.eventos.length == 0 ? true : false : true" [options]="ctrl.optionSelect" (valueChanged)="seleccionarEvento($event); "
                  [data]="ctrl.eventos"></ng-select2>
              </div>
            </div>

          </div>

          <div class="is-fullwidth has-text-centered" *ngIf="cargando">
            <br>
            <span class="tag is-primary is-large ">
              <span class="icon">
                <i class="icon-worldwide fa-spin"></i>
              </span> &nbsp;
              <span>Cargando...</span>
            </span>
          </div>

          <section class="tile is-ancestor" *ngIf="dato">
            <div class="tile is-vertical is-12">
              <div class="tile">
                <div class="tile">
                  <div class="tile is-parent" >
                    <article class=" tile is-child notification"  >
                      <p class="subtitle">
                        <i class="icon-certificate "></i> Constancias configuradas
                      </p>
                      <div class="fa has-text-black">

                      </div>

                      <div class="content" style="font-size: 4em;">

                        {{dato.eventos_constancias.length}}
                      </div>
                    </article>
                  </div>
                </div>

                <div class="tile">
                  <div class="tile is-parent">
                    <article class=" tile is-child notification">
                      <p class="subtitle">
                        <i class="icon-election "></i> Personas confirmadas
                      </p>
                      <div class="fa has-text-black">

                      </div>

                      <div class="content" >

                        <span style="font-size: 4em;">{{dato.confirmados.length}}</span>
                        <span style="font-size: 2em;">de {{dato.registrados.length}}</span>
                      </div>
                    </article>
                  </div>
                </div>
              </div>
              <div class="tile">
                <div class="tile is-parent">
                  <article class=" tile is-child notification">
                    <p class="subtitle">
                      <i class="icon-printer "></i> Imprimir
                    </p>

                    <div class="content">
                      <div class="columns">
                        <div class="column is-4" style="height: 100px;">
                          <button class="button is-fullwidth is-fullheight" type="button" (click)="imprimirEvento()" style="height: 100px;">
                            <span class="icon fa-4x has-text-link">
                              <i class="icon-printer"></i>
                            </span>
                            <span class="tooltiptext">Constancias</span>
                          </button>
                        </div>

                        <div class="column is-4" style="height: 100px;">
                          <button class="button is-fullwidth is-fullheight" type="button" (click)="imprimirInscritos()" style="height: 100px;">
                            <span class="icon fa-4x has-text-success">
                              <i class="icon-printer"></i>
                            </span>
                            <span class="tooltiptext">Lista de inscritos</span>
                          </button>
                        </div>

                        <div class="column is-4" style="height: 100px;">
                          <button class="button is-fullwidth is-fullheight" type="button" (click)="imprimirConfirmado()" style="height: 100px;">
                            <span class="icon fa-4x has-text-black">
                              <i class="icon-printer"></i>
                            </span>
                            <span class="tooltiptext">Lista confirmada</span>
                          </button>
                        </div>
                      </div>

                    </div>
                  </article>
                </div>
              </div>
            </div>
          </section>
        </section>
      </form>
    </div>
  </div>
</div>


